import { definePreset } from "@primevue/themes";
import Nora from "@primevue/themes/lara";
const MyPreset = definePreset(Nora, {
  semantic: {
    colorScheme: {
      light: {
        surface: {
          50: "{zinc.50}",
          100: "{zinc.100}",
          200: "{zinc.200}",
          300: "{blue.300}",
          400: "{blue.400}",
          500: "{blue.500}",
          600: "{blue.600}",
          700: "{zinc.700}",
          800: "{blue.800}",
          900: "{blue.900}",
          950: "{blue.950}",
        },
        primary: {
          50: "{blue.50}",
          100: "{blue.100}",
          200: "{blue.200}",
          300: "{blue.300}",
          400: "{blue.400}",
          500: "{blue.500}",
          600: "{blue.600}",
          700: "{blue.700}",
          800: "{blue.800}",
          900: "{blue.900}",
          950: "{blue.950}",
          activeColor: "{blue.500}",
        },
      },
    },
  },
});

export default MyPreset;
